import { slugify } from '@util/urlHelpers'

type Props = {
  title: string
  error?: string;
  children?: React.ReactNode;
}

export const CreateListingSection = ({ title, error, children }: Props) => {
  return (
    <div
      className='h-full w-full sm:rounded-3xl sm:border border-zinc-200 bg-white p-8 md:p-12 shadow-sm flex flex-col gap-8 md:gap-12'
      id={slugify(title)}>
      <div className="flex flex-col items-start gap-y-4 sm:flex-row sm:items-center">
        <div className="flex items-center">
          <h3 className="text-heading-h5 font-bold">{title}</h3>
        </div>
        {error && <p className="text-[1.3rem] text-brand-red">{error}</p>}
      </div>
      {children}
    </div>
  )
}
